import { Pipe, PipeTransform } from '@angular/core';

// Tell TypeScript this variable exists globally at runtime
declare const __webpack_public_path__: string;

@Pipe({
  name: 'remoteAssetUrl',
  standalone: true, // Set to true if using Standalone Components
})
export class RemoteAssetUrlPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    // In Module Federation, __webpack_public_path__ contains the remote's URL
    // We fall back to a relative path './' if it's not defined
    const baseUrl =
      typeof __webpack_public_path__ !== 'undefined'
        ? __webpack_public_path__
        : './';

    // Ensure we don't end up with double slashes if 'value' starts with one
    const cleanValue = value.startsWith('/') ? value.substring(1) : value;
    const cleanBase = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;

    return `${cleanBase}${cleanValue}`;
  }
}
